/***
 *
 *   PASSWORD
 *   Phase 8 — PasswordSection chrome. Keep create-vs-change live behavior.
 *
 **********/

import React, { useContext, useState } from 'react';
import { SettingsWrapper, Animate, Card, Form, Message } from 'components/lib';
import { AuthContext } from 'app/auth';
import { useTranslate } from 'app/translations';
import Style from './password.tailwind';

export function Password(props) {
    const { _t } = useTranslate();
    const context = useContext(AuthContext);
    const [done, setDone] = useState(false);
    const hasPassword = Boolean(context.user.has_password);

    return (
        <SettingsWrapper>
            <Animate>
                <div className={Style.stack}>
                    <div>
                        <h1 className={Style.title}>
                            {hasPassword ? _t('password.change') : _t('password.create')}
                        </h1>
                        <p className={Style.description}>{_t('password.update')}</p>
                    </div>

                    <Card
                        title={_t('password.update')}
                        description={
                            hasPassword ? _t('password.change') : _t('password.create')
                        }
                        className={props.className}>
                        {!done ? (
                            <Form
                                url="/api/user/password"
                                method="PUT"
                                buttonText={_t('password.save')}
                                data={{
                                    ...(hasPassword && {
                                        oldpassword: {
                                            label: _t('password.old'),
                                            type: 'password',
                                            required: true,
                                        },
                                        has_password: {
                                            type: 'hidden',
                                            value: true,
                                        },
                                    }),
                                    newpassword: {
                                        label: _t('password.createNew'),
                                        type: 'password',
                                        required: true,
                                        complexPassword: true,
                                    },
                                    confirmPassword: {
                                        label: _t('password.confirmNew'),
                                        type: 'password',
                                        required: true,
                                        complexPassword: true,
                                    },
                                }}
                                callback={() => {
                                    setDone(true);
                                    context.update({ has_password: true });
                                }}
                            />
                        ) : (
                            <Message
                                title={_t('password.saved')}
                                type="success"
                                text={_t('password.newSucess')}
                            />
                        )}
                    </Card>
                </div>
            </Animate>
        </SettingsWrapper>
    );
}
